import React from 'react';
import { Row, Col, Button, TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import {inject, observer} from "mobx-react";
import CardContainerPai from "./CardContainerPai";
import ImportacaoEntradaDepotStore from '../stores/ImportacaoEntradaDepotStore';
import _ from "lodash";
import { IconeGenerico, IconeCarregar } from '../../../../comum/components/Icones';
import ModalAviso from "../../../../comum/components/ModalAviso";

@inject("store")
@observer
export default class ImportacaoEntradaDepot extends React.Component {
    constructor(props) {
        super(props);
        this.parametrosStore = this.props.store.parametrosStore;
        this.controller = new ImportacaoEntradaDepotStore()
        this.agendamentoController = this.props.agendamentoController;

        this.isSSA = !process.env.rig;
        this.isRIG = process.env.rig;
        this.state = {
            atualizado: true
        }
       
    };

    componentDidMount = () => {
        _.set(this.agendamentoController, 'isDepot', true);
        _.set(this.agendamentoController.dadosAgendamento, 'Containeres', []);
    }

    refresh = () => {
        this.setState({ atualizado: false });
    };

    refreshAoContrario = (string) => {
        console.log('entrou', string)
        this.controller.tipoConsultaAnterior = string
        this.setState({ atualizado: true });
    };

    ListaContainer() {
        console.log(this.controller)

        if (this.agendamentoController.isEditar) {
            if (! this.controller.dadosAgendamento.listaBookings)
                this.controller.abrirInserirNovoBooking();
            
            _.set(this.controller.dadosAgendamento, 'listaBookings', this.agendamentoController.dadosAgendamento.listaBookings);
            if (this.controller.dadosAgendamento.listaBookings) {

                this.controller.dadosAgendamento.listaBookings.map((book, x) => {
                    console.log('lista', book)
                })

                return this.controller.dadosAgendamento.listaBookings.map((book, x) => (
                        <Row key={x}>
                            <Col xl={12}>
                                <CardContainerPai
                                index={x}
                                booking={book}
                                agendamentoController={this.controller}
                                dado={`listaBookings[${x}]`}
                                adicionarNovoContainer={this.controller.abrirInserirNovoContainerFilho}
                                salvo={this.props.salvo}
                                codigoBooking={this.props.codigoBooking}
                                setStatusSalvo={this.props.setStatusSalvo}
                                setDado={this.controller.setDadosAgendamento}
                                removerContainer={this.controller.removerBookingContainer}
                                agendamento={this.agendamentoController}
                                refreshAoContrario={this.refreshAoContrario}
                                />
                            </Col>
                        </Row>))
                    } 
            
        } else {
            if (! this.controller.dadosAgendamento.listaBookings)
            this.controller.abrirInserirNovoBooking();

            if (this.controller.atualizaBookings)
                if (this.controller.dadosAgendamento.listaBookings) {

                return this.controller.dadosAgendamento.listaBookings.map((book, x) => (
                        <Row key={x}>
                            <Col xl={12}>
                                <CardContainerPai
                                    index={x}
                                    booking={ book }
                                    agendamentoController={this.controller}
                                    dado={ `listaBookings[${x}]` }
                                    adicionarNovoContainer={ this.controller.abrirInserirNovoContainerFilho }
                                    salvo={ this.props.salvo } 
                                    codigoBooking = {this.props.codigoBooking}
                                    setStatusSalvo = {this.props.setStatusSalvo}
                                    setDado={ this.controller.setDadosAgendamento }
                                    removerContainer={ this.controller.removerBookingContainer }
                                    agendamento={this.agendamentoController}
                                    refreshAoContrario={this.refreshAoContrario}
                                />
                            </Col>
                        </Row>))
                } else
                return null;
        }
    };

    navsContainer() {
        return <div>
            { !this.state.atualizado ? this.ListaContainer() : this.refresh() }
        </div>
    };

    render() {

    	return (
            <div>
                { this.navsContainer() }
            </div>
        );
    } 


}



// WEBPACK FOOTER //
// ./src/modules/agendamento/containers-cadastrar/importacao-entrada-depot/components/ImportacaoEntradaDepot.js